var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-4 toolbar-card", attrs: { elevation: "1" } },
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            { attrs: { align: "center" } },
            [
              !_vm.isEditingName
                ? _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "span",
                        { staticClass: "text-body-2 font-weight-medium" },
                        [_vm._v(_vm._s(_vm.$t("label.floor_plan")))]
                      ),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "ml-2 d-inline-block compact-select",
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.currentFloorPlan
                            ? _vm.currentFloorPlan.id
                            : null,
                          items: _vm.floorPlanOptions,
                          disabled: !_vm.currentFloorPlan,
                          placeholder: !_vm.currentFloorPlan
                            ? _vm.$t("label.no_floor_plan")
                            : undefined,
                          "item-value": "value",
                          "item-text": "text",
                          dense: "",
                          "hide-details": "",
                          outlined: "",
                          "aria-label": _vm.$t("label.floor_plan"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditingName && _vm.currentFloorPlan
                ? _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "span",
                        { staticClass: "text-body-2 font-weight-medium" },
                        [_vm._v(_vm._s(_vm.$t("label.floor_plan")))]
                      ),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "ml-2 d-inline-block compact-select",
                        staticStyle: { width: "200px" },
                        attrs: {
                          dense: "",
                          "hide-details": "",
                          outlined: "",
                          autofocus: "",
                          "aria-label": _vm.$t("label.edit_name"),
                        },
                        on: {
                          keydown: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.saveNameEdit.apply(null, arguments)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape",
                                ])
                              ) {
                                return null
                              }
                              return _vm.cancelNameEdit.apply(null, arguments)
                            },
                          ],
                        },
                        model: {
                          value: _vm.editingName,
                          callback: function ($$v) {
                            _vm.editingName = $$v
                          },
                          expression: "editingName",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-col", { attrs: { cols: "auto" } }, [
                !_vm.isEditingName
                  ? _c(
                      "span",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              disabled: !_vm.currentFloorPlan,
                              "aria-label": _vm.$t("action.edit_name"),
                            },
                            on: { click: _vm.startNameEdit },
                          },
                          [_c("v-icon", [_vm._v("mdi-pencil")])],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEditingName
                  ? _c(
                      "span",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              color: "primary",
                              "aria-label": _vm.$t("action.save_name"),
                            },
                            on: { click: _vm.saveNameEdit },
                          },
                          [_c("v-icon", [_vm._v("mdi-check")])],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        small: "",
                        "aria-label": _vm.$t("action.add"),
                        "data-testid": "add-floor-plan",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("add")
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-plus")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        small: "",
                        loading: _vm.deleting,
                        disabled: _vm.deleting || !_vm.currentFloorPlan,
                        "aria-label": _vm.$t("action.delete"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("delete")
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-delete")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.hasUnsavedChanges && !_vm.saving
                ? _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-0 pa-1",
                          attrs: { type: "warning", dense: "", text: "" },
                        },
                        [
                          _c("span", { staticClass: "text-caption" }, [
                            _vm._v(_vm._s(_vm.$t("msg.unsaved_changes"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.saving
                ? _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-0 pa-1",
                          attrs: { type: "info", dense: "", text: "" },
                        },
                        [
                          _c("span", { staticClass: "text-caption" }, [
                            _vm._v(_vm._s(_vm.$t("msg.saving"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasUnsavedChanges
                ? _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            color: "primary",
                            small: "",
                            loading: _vm.saving,
                            disabled: _vm.saving,
                            "data-testid": "save-floor-plan",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("save")
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                            _vm._v("mdi-content-save"),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("action.save")) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("cancel")
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                            _vm._v("mdi-close"),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("action.cancel")) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "mt-4", attrs: { align: "end" } },
            [
              _c("v-col", { attrs: { cols: "auto" } }, [
                _c("div", { staticClass: "control-group" }, [
                  _c("span", { staticClass: "control-group__label" }, [
                    _vm._v(_vm._s(_vm.$t("label.month"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-inline-block compact-select",
                      staticStyle: { width: "90px" },
                    },
                    [
                      _c("month-field", {
                        attrs: {
                          value: _vm.selectedMonth,
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          "data-testid": "month-selector",
                        },
                        on: {
                          input: function (value) {
                            return _vm.$emit("month-change", value)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("v-col", { attrs: { cols: "auto" } }, [
                _c(
                  "div",
                  { staticClass: "control-group" },
                  [
                    _c("span", { staticClass: "control-group__label" }, [
                      _vm._v(_vm._s(_vm.$t("label.display_mode"))),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      staticClass: "compact-select",
                      staticStyle: { width: "160px" },
                      attrs: {
                        value: _vm.displayMode,
                        items: _vm.displayModeOptions,
                        disabled: !_vm.currentFloorPlan,
                        "item-value": "value",
                        "item-text": "text",
                        dense: "",
                        "hide-details": "",
                        outlined: "",
                        "aria-label": _vm.$t("label.display_mode"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("display-mode-change", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("v-col", { attrs: { cols: "auto" } }, [
                _c("div", { staticClass: "control-group" }, [
                  _c("span", { staticClass: "control-group__label" }, [
                    _vm._v(_vm._s(_vm.$t("label.detection_filter"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "detection-filter",
                        { "detection-filter--disabled": !_vm.currentFloorPlan },
                      ],
                      attrs: {
                        role: "radiogroup",
                        "aria-label": _vm.$t("label.detection_filter"),
                      },
                    },
                    _vm._l(_vm.detectionFilterOptions, function (option) {
                      return _c(
                        "label",
                        {
                          key: option.value,
                          class: [
                            "filter-segment",
                            {
                              "filter-segment--active":
                                _vm.detectionFilter === option.value,
                            },
                          ],
                        },
                        [
                          _c("input", {
                            staticClass: "filter-segment__input",
                            attrs: {
                              type: "radio",
                              name: "detection-filter",
                              disabled: !_vm.currentFloorPlan,
                            },
                            domProps: {
                              value: option.value,
                              checked: _vm.detectionFilter === option.value,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit(
                                  "detection-filter-change",
                                  option.value
                                )
                              },
                            },
                          }),
                          _vm._v(
                            "\n              " +
                              _vm._s(option.label) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "d-flex align-center", attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        small: "",
                        loading: _vm.exporting,
                        disabled: _vm.exporting || !_vm.currentFloorPlan,
                        "aria-label": _vm.$t("action.download"),
                        "data-testid": "download-floor-plan",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("download")
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-download")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loadingEvents
        ? _c("v-progress-linear", {
            staticClass: "toolbar-progress",
            attrs: { indeterminate: "", color: "primary", height: "2" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }